import { DEFAULT_RP_SECTION_ORDER } from '../../stores/playSessionStore';

/** Merge sectionOrder with default built-in IDs for forward compatibility */
export function mergeWithDefaults(sectionOrder: string[]): string[] {
  const merged = [...sectionOrder];
  for (const id of DEFAULT_RP_SECTION_ORDER) {
    if (!merged.includes(id)) merged.push(id);
  }
  return merged;
}

/** Built-in section labels by ID */
export const BUILT_IN_SECTION_LABELS: Record<string, string> = {
  identity: 'Identity Card',
  personality: 'Personality',
  motivations: 'Motivations',
  backstory: 'Backstory',
  features: 'Heritage & Training',
  tools: 'Tool Proficiencies',
  feats: 'Feats',
  equipment: 'Equipment & Wealth',
  notes: 'Session Notes',
};
